import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import { Table } from '../../styles';
import { calculateRatingColor } from '../../../../../core/utils/calculateRatingColor';

export const Header = styled(Table.Header)``;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 100%;
`;

export const HeaderColumn = styled(Table.HeaderCell)`
 flex: 1;
 min-width: 0;
`;

export const Body = styled(Table.Body)`
  border-bottom: none;
`;

export const Column = styled(Table.Cell)`
 flex: 1;
 padding: 1em;
`;

export const RowTable = styled(Table.Row)`
 display: flex;
`;

export const ColoredQuestionRating = styled(TextLayoutComponent)`
  background-color: ${(props) => calculateRatingColor(props.percentage)};
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 12px;
`;

export const FieldQuestionRate = styled(TextLayoutComponent)`
  background-color: #F4F4F4;
  width: fit-content;
  display: flex;
  flex-direction: column;
  padding: 5px 7px;
  border-radius: 4px;
  margin-top: 5px;
  font-size: 12px;
`;

export const LearnMoreLink = styled.a`
  font-size: 10px;
`;

export const EditNumberButton = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.primary};
  cursor: pointer;
  padding-top: 0.5em;
  display: inline-block;
`;

export const ContainerAnswerButton = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
  margin-top: 0.5em;
`;

export const Text = styled(TextLayoutComponent)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 270px;
  gap: 8px;
`;

export const TextQuestionOption = styled(TextLayoutComponent)`
`;

export const RattingOption = styled(TextLayoutComponent)`
  background-color: #F4F4F4;
  width: fit-content;
  padding: 5px;
  border-radius: 4px;
`;
